import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Dispensing from 'components/customComponents/Experiment/Dispensing/Dispensing';
import ExperimentInfoDetails from 'components/customComponents/Experiment/ExperimentInfo/ExperimentInfoDetails';

import { DisplayModes, ExperimentRoutes, SetExpRoute } from 'utils/Global';
import ImagingSchedule from '../customComponents/Experiment/ImagingSchedule/ImagingSchedule';
import { ExperimentInfoProps } from 'business/models/CustomModels';
import ScreenLot from 'components/customComponents/Experiment/ScreenLot/ScreenLot';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import useRMLite from 'CustomHooks/useRMLite';
import { setOriginalExpData } from 'redux/reducers/experimentDataReducer';

export default function ExperimentInfo(props: ExperimentInfoProps) {
  const exp = useRMSelector((state) => state.experiment.expData);
  const dispatch = useRMDispatch();

  const [refresh, setRefresh] = useState(0);
  const rmLite = useRMLite();

  const { id } = useParams();
  useEffect(() => {
    props.setHeader(DisplayModes.EXPINFO);
    SetExpRoute(ExperimentRoutes.EXPINFO);
    dispatch(setOriginalExpData());
  }, []);

  useEffect(() => {
    if (refresh) {
      setRefresh(0);
    }
  }, [refresh]);

  useEffect(() => {
    if (exp) {
      props.setIsInfoLoaded(true);
    } else {
      props.setIsInfoLoaded(false);
    }
  }, [exp]);

  if (exp === null || exp === undefined) {
    return <div id="experimentinfo-loading">Loading Experiment Info...</div>;
  }
  return (
    <>
      <div id="experimentinfo-main-wrapper" className="flex flex-row w-full m-2 gap-2">
        <div
          id="experimentinfo-left-column"
          className="w-1/3 overflow-y-auto border-dashed border-[1px] border-[#9E9E9E]"
        >
          <fieldset id="experimentinfo-fieldset-details" disabled={rmLite}>
            <ExperimentInfoDetails
              setRefresh={props.setRefresh}
              experimentId={id}
              isScreenRoute={props.isScreenRoute}
            />
          </fieldset>
        </div>
        <div
          id="experimentinfo-center-column"
          className="w-1/3 overflow-y-auto border-dashed border-[1px] border-[#9E9E9E]"
        >
          <fieldset
            id="experimentinfo-fieldset-imagingschedule"
            disabled={rmLite}
            className="h-full"
          >
            {!props.isScreenRoute ? (
              <ImagingSchedule
                id="experimentinfo-imagingschedule"
                setRefresh={props.setRefresh}
                expId={id}
              />
            ) : (
              <ScreenLot id="experimentinfo-screenlot" />
            )}
          </fieldset>
        </div>
        <div
          id="experimentinfo-right-column"
          className="w-1/3 overflow-hidden overflow-y-auto border-dashed border-[1px] border-[#9E9E9E]"
        >
          <fieldset id="experimentinfo-fieldset-dispensing" disabled={rmLite}>
            <Dispensing />
          </fieldset>
        </div>
      </div>
    </>
  );
}
